import { Grid, createTheme, ThemeProvider, CssBaseline } from "@mui/material";
import * as React from "react";
import LoginPanel from "components/mnl/auth/loginPanel";
import ConfirmEmailForm from "components/mnl/auth/confirmEmailForm";
const theme = createTheme();
const ConfirmEmailPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <LoginPanel />
        <ConfirmEmailForm />
      </Grid>
    </ThemeProvider>
  );
};
export default ConfirmEmailPage;
